import { ReactElement } from 'react';
import { CartReplacement } from '@mapado/seating';
import EventDatePagesHeader from '../components/EventDatePagesHeader';
import useQueryNumberParam from '../useQueryNumberParam';

export default function DemoCartReplacement(): ReactElement {
  const cartId = useQueryNumberParam('cartId', 1125668);
  const eventDateId = useQueryNumberParam('eventDateId', 133018);

  return (
    <>
      <EventDatePagesHeader
        title="Replacement de commande"
        eventDateId={eventDateId}
      />

      <CartReplacement
        cartId={cartId}
        eventDateId={eventDateId}
        // eslint-disable-next-line no-console
        onDismissSeating={() => console.log('dismiss seating')}
      />
    </>
  );
}
